<template lang="pug">
.imagec.position-relative(
  ref="imageContainer",
  :class="{ horizontal: !vertical, vertical: vertical, covered: covered, 'surface-bg': background, background }"
)
  .placeholder
    icon.text-muted.mb-2(:icon="'fal images'", :class="{ 'fa-2x': !smallPlaceholder }")
    pr-text.title.text-muted.font-italic(weight="semibold", v-show="alt && error") {{ alt }}
</template>

<script>
export default {
  name: "imagec",
  props: {
    src: {
      type: String,
      default: ""
    },
    alt: {
      type: String,
      default: ""
    },
    route: {
      type: Boolean,
      default: true
    },
    smallPlaceholder: {
      type: Boolean,
      default: false
    },
    vertical: {
      type: Boolean,
      default: false
    },
    covered: {
      type: Boolean,
      default: false
    },
    background: {
      type: Boolean,
      default: true
    },
    fallback: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isLoaded: false,
      error: false
    }
  },
  watch: {
    src() {
      this.load()
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    load(fallback = false) {
      if (!this.src) return this.loaded(false)
      _$.loadImage(fallback ? this.fallback.host() : this.src.host(), this.route).then(img => {
        if (!img) return this.fallback ? this.load(true) : this.loaded(false)

        if (this.vertical) img.style.height = "100%"
        if (!this.vertical) img.style.width = "100%"
        this.$refs.imageContainer.innerHTML = img.outerHTML
        this.loaded(true)
      })
    },
    loaded(res) {
      this.isLoaded = true
      this.error = !res
      _$.sleep(50).then(() => this.$emit("loaded", res))
    }
  }
}
</script>

<style lang="scss">
.imagec {
  display: inline-block;
  position: relative;
  vertical-align: top;

  &.horizontal {
    width: 100%;

    &.covered {
      img {
        position: absolute;
        transform: translateY(-50%);
        top: 50%;
      }
    }
  }
  &.vertical {
    height: 100%;

    &.covered {
      img {
        position: absolute;
        transform: translateY(-50%);
        top: 50%;
      }
    }
  }

  img {
    display: block;
  }

  .placeholder {
    position: absolute;
    top: 5px;
    right: 10px;
    left: 10px;
    bottom: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    overflow: hidden;
  }
}
</style>
